module.exports = __webpack_public_path__ + "img/bj_sx@2x.233f549d.png";